import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { ItemApi } from 'src/features/common/item/item-api';
import { CallLogCustomer } from 'src/cad/administration/call-log/shared/interfaces/call-log-customer';
import ValidationResult = cad.ValidationResult;
import { isNil } from 'lodash';

@Injectable()
export class CustomerMaintenanceApi extends ItemApi {

  private readonly endpoint: string = 'administration/calllog/maintenance/customer';
  
  constructor(
    public apiHelper: ApiHelper
  ) {
    super();
  }
  
  public getById(callLogCustomerId: number): Observable<CallLogCustomer> {
    return this.apiHelper.request(this.endpoint + '/' + callLogCustomerId);
  }
  
  public find(filterData: CallLogCustomer): Observable<CallLogCustomer> {
    if (filterData && !isNil(filterData.callLogCustomerId)) {
      return this.getById(filterData.callLogCustomerId);
    } else {
      throw new Error('callLogCustomerId is invalid.');
    }
  }
  
  public filter(filterData: Partial<CallLogCustomer>): Observable<CallLogCustomer[]> {
    return this.apiHelper.request(`${ this.endpoint }/filter`, { body: filterData });
  }
  
  public recent(): Observable<CallLogCustomer[]> {
    return this.apiHelper.request(`${ this.endpoint }/dashboard`);
  }
  
  public save(saveData: CallLogCustomer): Observable<ValidationResult<CallLogCustomer>> {
    return this.apiHelper.request(`${ this.endpoint }/save`, { body: saveData });
  }
  
  public deleteItem(deleteData: CallLogCustomer): Observable<ValidationResult> {
    throw new Error('Method not implemented.');
  }
}
